import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import Authentication from './store/modules/authentication';
import CurrentEvent from './store/modules/currentEvent';
import Users from './store/modules/users';
import Speakers from './store/modules/speakers';
import Sponsors from './store/modules/sponsors';
import Documents from './store/modules/documents';
import Pages from './store/modules/pages';
import Info from './store/modules/info';
import Agendas from './store/modules/agendas';
import Timeline from './store/modules/timeline';
import Stream from './store/modules/stream';
import Sponsor from './store/modules/sponsor';
import Chat from '@/store/modules/chat';
import Stage from '@/store/modules/stage';
import BookSessions from '@/store/modules/bookSessions';
import Vouchers from '@/store/modules/vouchers';
import PublicGroups from '@/store/modules/publicGroups';
import Categories from '@/store/modules/categories';
import Terms from '@/store/modules/terms';
import Groups from '@/store/modules/groups';
import ResultsAuthentication from '@/store/modules/resultsAuthentication';
import Notifications from '@/store/modules/notifications';
import Accessibility from '@/store/modules/accessibility';
import Theme from '@/store/modules/theme';
import MatchingProfile from '@/store/modules/matchingProfile';
import Matches from '@/store/modules/matches';
import MatchDetail from '@/store/modules/matchDetail';
import MatchingTaxonomies from '@/store/modules/matchingTaxonomies';
import MyMeetings from '@/store/modules/myMeetings';
import AvailableSlots from '@/store/modules/availableSlots';
import OpenSessions from '@/store/modules/openSessions';
import PushNotifications from '@/store/modules/pushNotifications';
import Seating from '@/store/modules/seating';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['Terms', 'Accessibility']
});

export default new Vuex.Store({
  strict: true,
  modules: {
    Authentication,
    Chat,
    CurrentEvent,
    Documents,
    Sponsors,
    Users,
    Seating,
    Speakers,
    Pages,
    Info,
    Agendas,
    Timeline,
    Stage,
    Stream,
    Sponsor,
    BookSessions,
    Categories,
    Vouchers,
    PublicGroups,
    Groups,
    Terms,
    ResultsAuthentication,
    Notifications,
    Accessibility,
    Theme,
    MatchingProfile,
    Matches,
    MatchDetail,
    MatchingTaxonomies,
    MyMeetings,
    AvailableSlots,
    OpenSessions,
    PushNotifications
  },
  plugins: [vuexLocal.plugin]
});
